import { UserRights } from '../UserManagement/Types';

export enum IUserActionTypes {
	LOGIN = '@@user/LOGIN',
	LOGIN_ERROR = '@@user/LOGIN_ERROR',
	LOGIN_SUCCESS = '@@user/LOGIN_SUCCESS',
	LOGOUT = '@@user/LOGOUT',
	LOGOUT_SUCCESS = '@@user/LOGOUT_SUCCESS',
}

export interface IUserState {
	readonly expires: Date;
	readonly groupID: number;
	readonly token: string;
	readonly userInfo: IUserInfo;
	readonly username: string;
	readonly userManagementRights: UserRights;
}

export interface IUserInfo {
	readonly email: string;
	readonly firstname: string;
	readonly id: number;
	readonly name: string;
	readonly position: string | null;
}
